import React from 'react';
import { Typography, Image, Row, Col, Divider } from 'antd';
import { styles } from '../../../styles';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../../hooks/MediaQuery.hook';
import RelatedBlog from './RelatedBlogs';
import { DEFAULT_LEAGUE_LINK } from '../../../utils/constant';
import BlogFooter from '../../../components/BlogFooter';

const { Title, Paragraph } = Typography;

export default function Blog6() {

  const matches = useMediaQuery('(min-width: 768px)');


  return (
    <>
    <Row style={styles.navLinks}>        
       <p><Link to={'/'}>Home</Link> / <Link to={'/blogs'}>Blogs </Link>/ Man City Nightmare<span></span></p>
    </Row>
    <Row justify="center">
      <Col xs={24} sm={22} md={20} lg={16}>

        <div style={styles.blogContainer}>
          <Typography>
            <Title level={2} style={{...styles.mainHeading, fontSize: !matches ? '24px': ''}}>
            <a href="https://koostream.live/fixtures/team/Manchester%20City">MANCHESTER CITY</a> NIGHTMARE
            </Title>
            <Paragraph style={styles.blogParagraph}>
            A couple of years ago if you had asked any football fan, “who is the best unbeatable club “in England, their answer without any doubt would have been <a href="https://koostream.live/fixtures/team/Manchester%20City">Manchester City</a> because the man city standings were always on top. They have dominated the <Link to={DEFAULT_LEAGUE_LINK}> English Premier League</Link> for seven years by winning all major titles.
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            But this season of English Premier League witnessed the unthinkable. The champion club has been continuously declining in the performance and their coach Pep Guardiola is still hopeful that he would turn things around. 
            </Paragraph>

            <Image
              preview={false}
              src="https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/downfall-of-man-city.jpeg"
              alt="Manchester city downfall"
              style={{ borderRadius: '8px', width: matches ? '75%' : '95%', margin: '10px' }}
            />

            <Paragraph style={styles.blogParagraph}>
            At the Etihad Stadium, the manager of <a href="https://koostream.live/fixtures/team/Manchester%20City">Manchester City</a> Pep Guardiola has extended the contract for two more years. Looking at the nightmarish performances of the club now there are many questions regarding how long Guardiola can survived at his job without getting fire. If we look at the last 13 games then it will very shocking to witness that there were total number of 9 defeats and the number of wins were just one. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Now the fans of Manchester City who are very used to winning games are getting frustrated and annoying. They want their fairytale of dominance in the <Link to={DEFAULT_LEAGUE_LINK}>Premier League</Link> back at any cost .they are missing their brilliant runs of winning trophies and now not very subtly they are demanding that if Guardiola cannot things turn around then he should leave. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Which some of fans can see a very unfair demand? Because Guardiloa has been a great influence in the club and his influence cannot be denied. During the last seven seasons, it was him due to which Manchester City was led to six <a href="https://www.premierleague.com/premier-league-explained" rel='noreferrer' target='_blank'> Premier league titles</a> . Maybe it is because of his astonishing performance in the seven years that pep is very convinced he can make things right. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Now if we look critically about why <Link to="/fixtures/team/Manchester%20City">Manchester City</Link> has been failing to perform this season of <Link to={DEFAULT_LEAGUE_LINK}>English Premier League</Link> then the top cause has been the injuries of the players . Which has stopped the club to perform with their full potential. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            The knee injury of Rodri has been impacting the performance of the club, while many other key players <a href="https://www.transfermarkt.com/kyle-walker/profil/spieler/95424" rel='noreferrer' target='_blank'> Kyle Walker</a>, Jack Grealish has been absent from playing at very important matches. Along with all this, the star player of the club, Erling Haalaand has been facing the challenges to perform. He has missed many chances to score.  
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Manchester City still has many questions regarding fitness of many other players. Despite all this <a href="https://www.football365.com/news/man-city-guardiola-admits-unfairly-treated-incredible-star-deciding-block-transfer" rel='noreferrer'  target='_blank'>Pep Guardiola</a>  has been telling everyone that he cannot blame any players for the current situation of the club. He insisted that injuries are part of the game, and then has been very positive about the strong come back of the club. Only time will tell if Manchester City can turn around that tables and once again start winning trophies to go back to their glory.
            </Paragraph>

            
            <Divider />
            <Title level={4} style={{...styles.blogHeading, textAlign: 'start', fontSize: '18px' }}>
              Read More Below
            </Title>
            <div style={{ paddingRight: '10px' }}>
              <RelatedBlog excludedId={6} />
            </div>

            <BlogFooter />
          </Typography>
        </div>
      </Col>
    </Row>
    </>
  );
}
